import dotProp from 'dot-prop-immutable';

import * as actionTypes from './actiontypes';
import states from './states';

export default function chatlog_details(state = states.chatlog_details, action) {
    switch (action.type) {
        case actionTypes.UPDATE_CHATLOG_STATE: {

            // if (action.path === "message_filters.granularity") {
            //     const hour = 60 * 60 * 1000;
            //     const current_state = {
            //         ...state,
            //         message_scale: {
            //             ...state.message_scale,
            //             timestamp: {
            //                 ...state.message_scale.timestamp,
            //                 tickInterval: action.payload === "day" ? hour * 24 * 2 : (action.payload === "week" ? hour * 24 * 7 : (action.payload === "month" ? hour * 24 * 15 : hour * 6)),
            //                 mask: action.payload === "hour" ? 'HH:mm' : 'DD MMM',
            //             }
            //         },
            //     }
            //     return dotProp.set(current_state, action.path, action.payload);
            // }

            return dotProp.set(state, action.path, action.payload);
        }

        case actionTypes.MESSAGE_TIME_SERIES_LOADING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    message_time_series_loading: true,
                }
            }
        }

        case actionTypes.MESSAGE_TIME_SERIES_RECEIVED: {
            return {
                ...state,
                message_time_series: action.payload && action.payload.messagesTimeSeries ? action.payload.messagesTimeSeries : [...state.message_time_series],
                loaders: {
                    ...state.loaders,
                    message_time_series_loading: false,
                    message_time_series_load_error: false,
                }
            };
        }

        case actionTypes.MESSAGE_TIME_SERIES_LOAD_ERROR: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    message_time_series_loading: false,
                    message_time_series_load_error: true,
                }
            }
        }


        case actionTypes.TRAINING_MESSAGE_LOADING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    training_messages_loading: true,
                }
            }
        }

        case actionTypes.TRAINING_MESSAGE_LOAD_SUCCESS: {
            return {
                ...state,
                training_messages: action.payload.chatThreads,
                training_message_pagination: {
                    ...state.training_message_pagination,
                    more_pages: action.payload.chatThreads.length === 20
                },
                loaders: {
                    ...state.loaders,
                    training_messages_loading: false,
                    training_messages_load_error: false,
                    training_messages_sync_required: false,
                }
            };
        }

        case actionTypes.TRAINING_MESSAGE_LOAD_ERROR: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    training_messages_loading: false,
                    training_messages_load_error: true,
                }
            };
        }

        case actionTypes.MESSAGE_TRAINING_START: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    message_training: true,
                }
            }
        }

        case actionTypes.MESSAGE_TRAINING_END: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    message_training: false,
                }
            }
        }

        case actionTypes.MESSAGE_TRAINING_SUCCESS: {
            let training_messages = [...state.training_messages];
            if (action.payload.trainedMessage.text) {
                const index = training_messages.findIndex(msg => (msg.text === action.payload.trainedMessage.text));
                if (index !== -1) {
                    training_messages = [
                        ...state.training_messages.slice(0, index),
                        {
                            ...state.training_messages[index],
                            ...action.payload.trainedMessage
                        },
                        ...state.training_messages.slice(index + 1)
                    ];
                }
            }

            return {
                ...state,
                training_messages,
                loaders: {
                    ...state.loaders,
                    training_messages_sync_required: !action.isTrained,
                }
            }
        }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/data/redux/chatlog_details/reducers.js